module.exports = __webpack_public_path__ + "static/img/product4.17697f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product4.png
// module id = aPS9
// module chunks = 0